


<br>
<div>
  <p-table #dt [columns]="cols" [value]="systempermissions" [paginator]="false" [autoLayout]="true">
    <ng-template pTemplate="caption">
        <p class="rubrik">Hantera superanvändare</p>
     <div class="d-flex justify-content-start gap-2"><button class="btn border" (click)="exportToCSV()">Excel</button><button class="btn border" (click)="addSystemPermission();">Lägg till</button></div>
<br>

     <div>
            <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
            <input type="text" pInputText size="50" placeholder="Globalt filter" (input)="dt.filterGlobal($event.target.value, 'contains')" style="width:auto">
        <span class="ms-2">Antal poster: {{systempermissions?.length}}</span>
        </div>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                {{col.header}}
                <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>

            </th>
            <th>Action</th>
        </tr>

    </ng-template>
    <ng-template pTemplate="body" let-rowData let-i="rowIndex" let-columns="columns">
        <tr [pSelectableRow]="rowData">

            <td *ngFor="let col of columns">

                {{rowData[col.field]}}

            </td>
            <td style="text-align: center;"><span style="display: inline-block;"><i class="fa fa-trash" style="font-size:12px;" (click)="removeConfirmDialog(rowData)" title="Radera"></i><i class="fa fa-edit ms-2" style="font-size:12px;" (click)="edit(rowData)" title="Ändra"></i></span></td>

        </tr>
    </ng-template>
</p-table>

</div>

<p-dialog header="Editera system permission" [(visible)]="display" [closable]="true" appendTo="body" position="center" modal="true" maximizable="true">
  <app-admin-system-permissions-edit [formdata]="formdata" (doSave)="saveSystemPermission($event)" (doCancel)="cancelEdit()"></app-admin-system-permissions-edit>
</p-dialog>

<p-dialog header="Lägg till system permission" [(visible)]="displayaddsystempermission" [closable]="true" appendTo="body" position="center" modal="true" maximizable="true">
  <app-admin-system-permissions-add [formdata]="formdata" (doSave)="saveAddSystemPermissions($event)" (doCancel)="cancelAdd()"></app-admin-system-permissions-add>
</p-dialog>




